export function isHomeUrl(url: string): boolean {
  return url === '' || url === '/' || url.search('^[?].*$') > -1
}
